module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/mh-7ec670b4d72f8a614957322d46619007.svg";